import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const MASS_RETAG_ROUTE_NAME = Symbol('admin.players.mass-retag');
export const TRANSLATION_GROUP_MASS_RETAG = Symbol('admin.mass-retag');

export const MASS_RETAG_MUTATION_KEY = 'players.mass-retag';
export const MASS_RETAG_API_URL = 'admin/mass_retag/retag';

export const PLAYERS_MASSTAG_PERMISSIONS = {
  PLAYERS_RETAG: new Permission(
    PermissionsList.admin.MASSRETAG_RETAG,
  ),
};
